// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMediaAudioMedium = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.733 8.858a2.5 2.5 0 0 1-1.672.642H5.5v5h2.56a2.5 2.5 0 0 1 1.673.642l2.767 2.735V6.123zM16 9.5c0-.276.232-.504.486-.397.201.085.395.22.574.397a2.686 2.686 0 0 1 .44.575c.304.521.5 1.192.5 1.925 0 .732-.196 1.404-.5 1.925a2.685 2.685 0 0 1-.44.575 1.856 1.856 0 0 1-.574.397c-.254.107-.486-.12-.486-.397zM14 5v14c0 .866-1.025 1.322-1.669.743L8.73 16.257A1 1 0 0 0 8.06 16H4.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3.56a1 1 0 0 0 .67-.257l3.601-3.486C12.975 3.677 14 4.134 14 5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMediaAudioMedium;
